/* ═══════════════════════════════════════════════════════════════
   ANTIOX HOME — JS dédié aux sections antiox-*
   Onglets collections · flèche produits · accordéon auto-cycle ·
   lightbox UGC · add-to-cart AJAX (cart drawer du thème)
   ═══════════════════════════════════════════════════════════════ */
(function () {
  if (window.__axHome) return;
  window.__axHome = 1;

  /* ── Hero slider : rotation auto + points ── */
  function initHeroSlider(root) {
    if (root.__axInit) return;
    root.__axInit = 1;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.ax-hero__slide'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.ax-hero__dot'));
    var delay = parseInt(root.getAttribute('data-ax-hero-autoplay'), 10) || 0;
    var timer = null;
    var current = 0;

    function activate(i) {
      current = i;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    if (delay > 0) {
      timer = setInterval(function () {
        activate((current + 1) % slides.length);
      }, delay);
    }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        if (timer) { clearInterval(timer); timer = null; }
        activate(i);
      });
    });
  }

  /* ── Onglets collections ── */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.ax-products__tab');
    if (!tab) return;
    var section = tab.closest('.ax-products');
    if (!section) return;
    var idx = tab.getAttribute('data-ax-tab');
    section.querySelectorAll('.ax-products__tab').forEach(function (t) {
      t.classList.toggle('is-active', t === tab);
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
    });
    section.querySelectorAll('.ax-products__panel').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-ax-panel') === idx);
    });
  });

  /* ── Flèche défilement produits ── */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.ax-products__arrow');
    if (!arrow) return;
    var section = arrow.closest('.ax-products');
    var row = section && section.querySelector('.ax-products__panel.is-active .ax-products__row');
    if (row) row.scrollBy({ left: 700, behavior: 'smooth' });
  });

  /* ── Accordéon réassurance : auto-cycle + hover/clic ── */
  function initReassurance(root) {
    if (root.__axInit) return;
    root.__axInit = 1;
    var panels = Array.prototype.slice.call(root.querySelectorAll('.ax-reassurance__panel'));
    if (!panels.length) return;
    var delay = parseInt(root.getAttribute('data-ax-cycle'), 10) || 3200;
    var timer = null;
    var current = 0;

    function activate(i) {
      current = i;
      panels.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    activate(0);
    if (delay > 0 && !isMobile()) {
      timer = setInterval(function () {
        activate((current + 1) % panels.length);
      }, delay);
    }
    panels.forEach(function (p, i) {
      p.addEventListener('mouseenter', function () {
        if (isMobile()) return;
        stop();
        if (current !== i) activate(i);
      });
      p.addEventListener('click', function () {
        if (isMobile()) return;
        stop();
        activate(i);
      });
    });
  }

  /* ── Lightbox UGC ── */
  document.addEventListener('click', function (e) {
    var tile = e.target.closest('.ax-ugc__tile[data-ax-video]');
    if (tile) {
      var section = tile.closest('.ax-ugc');
      var lightbox = section && section.querySelector('.ax-ugc__lightbox');
      if (!lightbox) return;
      var video = lightbox.querySelector('video');
      video.src = tile.getAttribute('data-ax-video');
      lightbox.classList.add('is-open');
      video.play().catch(function () {});
      document.documentElement.style.overflow = 'hidden';
      return;
    }
    var box = e.target.closest('.ax-ugc__lightbox');
    if (box && !e.target.closest('video')) {
      closeLightbox(box);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.ax-ugc__lightbox.is-open');
    if (open) closeLightbox(open);
  });
  function closeLightbox(box) {
    var video = box.querySelector('video');
    video.pause();
    video.removeAttribute('src');
    video.load();
    box.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  /* ── Add-to-cart AJAX (ouvre le cart drawer du thème) ── */
  function openCartDrawer(sectionsHtml) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var sections = drawer.getSectionsToRender();
    sections.forEach(function (s) {
      var el = document.querySelector(s.selector || '#' + s.id);
      if (el && sectionsHtml[s.id]) {
        var tmp = document.createElement('div');
        tmp.innerHTML = sectionsHtml[s.id];
        var target = tmp.querySelector(s.selector || '#' + s.id);
        if (target) el.innerHTML = target.innerHTML;
      }
    });
    drawer.open();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ax-atc-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    var drawer = document.querySelector('cart-drawer');
    var sectionIds = drawer ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var body = { items: [{ id: parseInt(vid, 10), quantity: 1 }] };
    if (sectionIds.length) body.sections = sectionIds.join(',');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.textContent = '✓ Ajouté';
        btn.classList.add('ax-atc-btn--done');
        setTimeout(function () {
          btn.textContent = label;
          btn.disabled = false;
          btn.classList.remove('ax-atc-btn--done');
        }, 2000);

        var drawer2 = document.querySelector('cart-drawer');
        if (drawer2) {
          drawer2.classList.remove('is-empty');
          var cdi = drawer2.querySelector('cart-drawer-items');
          if (cdi) cdi.classList.remove('is-empty');
        }
        if (data.sections) {
          openCartDrawer(data.sections);
        } else {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          });
          if (drawer) drawer.open();
        }
      })
      .catch(function () {
        btn.textContent = 'Erreur';
        setTimeout(function () {
          btn.textContent = label;
          btn.disabled = false;
        }, 2000);
      });
  });

  /* ── Autoplay vidéos : certains navigateurs ne déclenchent pas
     l'attribut autoplay seul ; on force play() quand la vidéo est visible ── */
  function initAutoplay(scope) {
    var videos = (scope || document).querySelectorAll('.ax-section video[autoplay], .ax-section video[data-ax-autoplay]');
    if (!videos.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var v = entry.target;
        v.muted = true;
        v.play().catch(function () {
          setTimeout(function () { v.play().catch(function () {}); }, 300);
        });
      });
    }, { rootMargin: '100px' });
    videos.forEach(function (v) { io.observe(v); });
  }

  /* ── Init au chargement + support de l'éditeur de thème ── */
  function initAll() {
    document.querySelectorAll('.ax-reassurance').forEach(initReassurance);
    document.querySelectorAll('.ax-hero').forEach(initHeroSlider);
    initAutoplay(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var reas = e.target.querySelector && e.target.querySelector('.ax-reassurance');
    if (reas) initReassurance(reas);
    var hero = e.target.querySelector && e.target.querySelector('.ax-hero');
    if (hero) initHeroSlider(hero);
    initAutoplay(e.target);
  });
})();
